export default "__VITE_ASSET__BB5zwqfk__"